<template>
  <div
    :class="{ 'drag-enter': dragEnter }"
    class="file-uploader text-faded cursor-pointer"
    @dragover="dragEnter = true"
    @dragleave="dragEnter = false"
    @drop="dragEnter = false"
  >
    <div v-if="stackLabel" :class="!!value ? 'text-secondary-1' : 'text-grey3'" class="stack-label text-caption-1">
      {{ stackLabel }}
    </div>

    <div v-if="!value" class="no-files">
      <div class="file cursor-pointer" @click="$refs.uploader.click()">
        <slot>
          <div class="text-body-3 text-grey2">{{ noFilesTitle }}</div>
        </slot>
      </div>
      <input
        ref="uploader"
        class="hidden-input cursor-pointer"
        type="file"
        @change="$emit('input', $event.target.files[0])"
      />
    </div>

    <Grid v-else gtc="1fr auto" align-items="center" align-content="center" gap="var(--r-space-xs)" class="full-height">
      <div :class="{ 'q-mt-md': !!stackLabel }" class="text-body-1 text-secondary-1">File name: {{ value.name }}</div>
      <div :class="{ 'q-mt-md': !!stackLabel }" class="actions">
        <q-btn
          v-if="showDownload"
          flat
          round
          size="xs"
          icon="fas fa-download"
          @click="download(value.license_file.id)"
        />

        <TrashIcon @click.native="$emit('input', null)" />
      </div>
    </Grid>
  </div>
</template>

<script>
import TrashIcon from '@/ui/icons/TrashIcon'

export default {
  components: {
    TrashIcon
  },

  props: {
    noFilesTitle: {
      type: String,
      default: 'Choose or drag file here'
    },
    value: [File, Object],
    stackLabel: String
  },

  data: () => ({
    dragEnter: false
  }),

  computed: {
    showDownload() {
      return !(this.value instanceof File)
    }
  },

  methods: {
    download(id) {
      this.$store.dispatch('downloadMedia', id, { root: true })
    }
  }
}
</script>

<style lang="scss" scoped>
.file-uploader {
  display: grid;
  position: relative;
  min-height: calc(var(--r-field-height) + var(--r-space-lg));
  font-size: 14px;
  font-weight: 300;
  padding: 0 12px;
  border: 1px dashed var(--r-white-5);
  border-radius: var(--space-xs);

  &.drag-enter {
    border: 1px solid;
  }

  .has-files,
  .no-files {
    display: flex;
    justify-content: space-between;
    height: 100%;
    align-items: center;
  }

  .no-files {
    justify-content: center;

    .hidden-input {
      position: absolute;
      height: 100%;
      width: 100%;
      opacity: 0;
    }
  }
  .stack-label {
    position: absolute;
    left: 12px;
    top: 6px;
  }
}
</style>
